import { useNavigationItemsConfig } from 'applications/GSP/layouts/MainLayout/components/Sidebar/hooks/useNavigationItemsConfig';
import { useUserRole } from 'applications/GSP/shared/hooks/user';
import { getNavigationItemsByRole } from 'applications/GSP/shared/utils/router';

import type { NavigationItem } from 'applications/GSP/layouts/MainLayout/components/Sidebar/types';

export const useNavigationItems = (): NavigationItem[] => {
  const navigationItems = useNavigationItemsConfig();
  const role = useUserRole();

  return getNavigationItemsByRole(role, navigationItems);
};
